export function getQueryKey(queryKey) {
    return ['Xhr', queryKey];
}
//# sourceMappingURL=getQueryKey.js.map